var map = {
	"./01_get_contracts.json": "mCcU",
	"./02_get_premiumIndex.json": "nco7",
	"./03_get_openInterest.json": "pnyN",
	"./04_get_kline.json": "Yskp",
	"./05_get_depth.json": "2qcG",
	"./06_get_ticker.json": "PaEN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9SsD";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/market \.json$
// module id = 9SsD
// module chunks = 3